










import Vue, { PropOptions } from 'vue';

const ErrorList = Vue.extend({
	props: {
		errorList: {
			type: Array,
			default() {
				return [];
			},
		} as PropOptions<string[]>,
		type: {
			type: String,
			default: 'custom',
		},
	},
	computed: {
		errors(): string[] {
			return this.type === 'custom'
				? this.errorList
				: this.$store.state.generalErrors;
		},
	},
});

export default ErrorList;
